import { NotificationsService } from '@notifications/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MarkNotificationAsClickedPathParams } from '@core-http';

export class MarkNotificationAsClickedCommandHandler {
  private readonly notificationsService: NotificationsService = inject(NotificationsService);

  markAsClicked(notificationId: string): Observable<void> {
    const pathParams: MarkNotificationAsClickedPathParams = { notificationId };

    return this.notificationsService.markAsClicked(pathParams);
  }
}
